module.exports = __webpack_public_path__ + "e968612c0f0f6bd1c07c6771b26e0750.jpg";